import { render } from "./AdminHorarios.vue?vue&type=template&id=442e6170&scoped=true"
import script from "./AdminHorarios.vue?vue&type=script&lang=js"
export * from "./AdminHorarios.vue?vue&type=script&lang=js"

import "./AdminHorarios.vue?vue&type=style&index=0&id=442e6170&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442e6170"]])

export default __exports__